import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V1 } from '@studio/constants/env-variables';
import type { Customer } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V1}/contactsearch`,
    query: {} as {
      email?: string;
      first?: string;
      last?: string;
      mobile?: string;
    },
    response: [] as Customer.Get.Contact[],
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
